import React, { useState } from 'react';
import './Recipes.css';

// Import recipe images
import KajunShrimpSausageSkillet from '../../assets/Kajun_Shrimp_Sausage_Skillet.png';
import KajunRoastedChickenThighs from '../../assets/Kajun_Roasted_Chicken_Thighs.png';
import PeachGingerGlazedSalmon from '../../assets/peach_ginger_glazed_salmon.png';
import PeachGingerGlazedPorkChops from '../../assets/peach_ginger_glazed_pork_chops.png';
import KajunButterGarlicCorn from '../../assets/kajun_butter_garlic_corn.png';
import KajunButterShrimpPasta from '../../assets/kajun_butter_shrimp_pasta.png';
import SpicyKajunWings from '../../assets/spicy_kajun_wings.png';
import SpicyKajunRedJambalaya from '../../assets/spicy_kajun_red_jambalaya.png';

const Recipes = () => {
  const [expandedRecipe, setExpandedRecipe] = useState(null);

  const recipesData = [
    {
      seasoning: "Original Kajun Blend",
      profile: "Smoky, savory, mild-to-medium heat — the all-purpose Kajun classic",
      color: "#d32f2f",
      recipes: [
        {
          id: "original-1",
          title: "Kajun Shrimp & Sausage Skillet",
          description: "Perfect for meal prep, tacos, over rice, or by itself. Classic Kajun flavors shine through.",
          image: KajunShrimpSausageSkillet,
          ingredients: [
            "1 lb shrimp, peeled/deveined",
            "8 oz smoked sausage, sliced",
            "1 tbsp Original Kajun Blend",
            "1 bell pepper (any color), sliced",
            "1 small onion, sliced",
            "2 tbsp olive oil",
            "1 tbsp lemon juice"
          ],
          instructions: [
            "Heat oil in a skillet. Add sausage and sear until browned.",
            "Add peppers and onions and sauté 3–4 minutes.",
            "Add shrimp + Kajun seasoning and cook until pink.",
            "Finish with lemon juice.",
            "Serve over rice or cauliflower rice."
          ],
          serving: "Serve over rice or cauliflower rice for a complete meal"
        },
        {
          id: "original-2",
          title: "Kajun Roasted Chicken Thighs",
          description: "Perfect for weeknight dinners and meal prep — crispy skin, bold flavor.",
          image: KajunRoastedChickenThighs,
          ingredients: [
            "4–6 chicken thighs",
            "2 tbsp Original Kajun Blend",
            "2 tbsp olive oil",
            "1 tbsp honey (optional)"
          ],
          instructions: [
            "Preheat oven to 425°F.",
            "Coat chicken with oil + seasoning.",
            "Roast 25–35 minutes until crispy skin forms.",
            "Brush with honey for a glossy finish (optional)."
          ],
          serving: "Pairs beautifully with roasted vegetables or a fresh salad"
        }
      ]
    },
    {
      seasoning: "Peach-Ginger Sweet Heat",
      profile: "Sweet upfront with warm spice and fruity notes — perfect for glazing and grilling",
      color: "#ff6f00",
      recipes: [
        {
          id: "peach-1",
          title: "Peach-Ginger Glazed Salmon",
          description: "Elegant dinner perfection. Sugar caramelizes, peaches brighten, ginger warms.",
          image: PeachGingerGlazedSalmon,
          ingredients: [
            "4 salmon fillets",
            "2 tbsp Peach-Ginger Sweet Heat",
            "1 tbsp soy sauce",
            "1 tbsp melted butter",
            "1 tbsp lemon juice"
          ],
          instructions: [
            "Mix butter, soy, lemon, and 1 tbsp seasoning for glaze.",
            "Brush salmon heavily with glaze.",
            "Bake at 400°F for 12–15 minutes OR grill until char marks appear.",
            "Sprinkle ½–1 tsp seasoning after cooking for extra flavor."
          ],
          serving: "Serve with jasmine rice and steamed asparagus"
        },
        {
          id: "peach-2",
          title: "Peach-Ginger Pork Chops",
          description: "Sweet heat meets savory pork — perfect for summertime grilling.",
          image: PeachGingerGlazedPorkChops,
          ingredients: [
            "4 pork chops",
            "2 tbsp Peach-Ginger Sweet Heat",
            "2 tbsp olive oil",
            "1 tbsp apple cider vinegar"
          ],
          instructions: [
            "Rub chops with seasoning + oil.",
            "Sear in skillet OR grill 3–4 min per side.",
            "Add vinegar at the end to create a sticky glaze.",
            "Let rest 5 minutes before serving."
          ],
          serving: "Best with grilled peaches and a fresh summer salad"
        }
      ]
    },
    {
      seasoning: "Butter Kajun Blend",
      profile: "Rich, buttery, savory — ideal for seafood, vegetables, popcorn, and pasta",
      color: "#ffa000",
      recipes: [
        {
          id: "butter-1",
          title: "Kajun Butter Garlic Corn",
          description: "Street corn style perfection — insanely addictive BBQ side.",
          image: KajunButterGarlicCorn,
          ingredients: [
            "4 ears corn (grilled or boiled)",
            "3 tbsp melted butter",
            "1–2 tsp Butter Kajun Blend",
            "Optional: parmesan or cotija cheese"
          ],
          instructions: [
            "Mix butter + Kajun Butter seasoning.",
            "Brush over hot corn.",
            "Sprinkle cheese (optional).",
            "Serve hot."
          ],
          serving: "The ultimate BBQ side — pairs with everything"
        },
        {
          id: "butter-2",
          title: "Kajun Butter Shrimp Pasta",
          description: "Creamy comfort food at its finest — restaurant quality at home.",
          image: KajunButterShrimpPasta,
          ingredients: [
            "1 lb shrimp",
            "1 tbsp Butter Kajun Blend",
            "3 tbsp butter",
            "2 cloves garlic, minced",
            "½ cup heavy cream",
            "Cooked pasta of your choice"
          ],
          instructions: [
            "Season shrimp with Butter Kajun Blend.",
            "Melt butter and sauté garlic 1 min.",
            "Add shrimp and cook until pink.",
            "Pour in cream + toss in pasta.",
            "Add a pinch more seasoning before serving."
          ],
          serving: "Garnish with fresh parsley and parmesan"
        }
      ]
    },
    {
      seasoning: "Spicy Red Kajun Blend",
      profile: "Hotter Kajun profile — smoky, bold, and seriously spicy",
      color: "#b71c1c",
      recipes: [
        {
          id: "spicy-1",
          title: "Spicy Kajun Wings",
          description: "Game day perfection — crispy, spicy, addictive.",
          image: SpicyKajunWings,
          ingredients: [
            "2 lbs chicken wings",
            "1 tbsp oil",
            "1–2 tbsp Spicy Red Kajun Blend",
            "1 tsp baking powder (for crispiness)"
          ],
          instructions: [
            "Preheat oven to 425°F or air fryer to 400°F.",
            "Toss wings with oil, baking powder, and seasoning.",
            "Cook until crispy (25–40 min oven, 18–20 min air fryer).",
            "Add more seasoning to finish for an extra kick."
          ],
          serving: "Serve with ranch or blue cheese dressing and celery sticks"
        },
        {
          id: "spicy-2",
          title: "Spicy Kajun Red Jambalaya",
          description: "Authentic Louisiana flavors in 30 minutes — spicy, smoky, perfect.",
          image: SpicyKajunRedJambalaya,
          ingredients: [
            "1 cup long-grain rice",
            "1 lb andouille sausage, sliced",
            "½ lb chicken or shrimp",
            "1 tbsp Spicy Red Kajun Blend",
            "1 can diced tomatoes",
            "2 cups chicken broth",
            "½ onion, chopped",
            "½ bell pepper, chopped",
            "2 cloves garlic"
          ],
          instructions: [
            "Sauté sausage, onion, bell pepper, garlic.",
            "Add chicken/shrimp + seasoning.",
            "Stir in rice, tomatoes, broth.",
            "Cover and simmer 20–25 minutes.",
            "Fluff and serve."
          ],
          serving: "Top with green onions and hot sauce for extra heat"
        }
      ]
    }
  ];

  const toggleRecipe = (recipeId) => {
    setExpandedRecipe(expandedRecipe === recipeId ? null : recipeId);
  };

  const copyRecipe = (recipe) => {
    const recipeText = `${recipe.title}\n\n${recipe.description}\n\nIngredients:\n${recipe.ingredients.map(i => `• ${i}`).join('\n')}\n\nInstructions:\n${recipe.instructions.map((step, i) => `${i + 1}. ${step}`).join('\n')}${recipe.serving ? `\n\nServing Suggestion:\n${recipe.serving}` : ''}`;
    navigator.clipboard.writeText(recipeText);
    alert('Recipe copied to clipboard!');
  };

  const printRecipe = (recipe) => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write(`
      <html>
        <head>
          <title>${recipe.title}</title>
          <style>
            body { font-family: Georgia, serif; padding: 40px; line-height: 1.6; }
            h1 { color: #b22222; margin-bottom: 10px; }
            h2 { color: #333; margin-top: 30px; }
            ul, ol { margin: 20px 0; }
            li { margin: 8px 0; }
            .description { font-style: italic; color: #555; margin-bottom: 20px; }
          </style>
        </head>
        <body>
          <h1>${recipe.title}</h1>
          <p class="description">${recipe.description}</p>
          <h2>Ingredients</h2>
          <ul>${recipe.ingredients.map(i => `<li>${i}</li>`).join('')}</ul>
          <h2>Instructions</h2>
          <ol>${recipe.instructions.map(step => `<li>${step}</li>`).join('')}</ol>
          ${recipe.serving ? `<h2>Serving Suggestion</h2><p>${recipe.serving}</p>` : ''}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div className="recipes-page">
      <div className="recipes-hero">
        <div className="container">
          <h1 className="recipes-main-title">Kajun Kitchen Recipes</h1>
          <p className="recipes-subtitle">Authentic Louisiana flavor in every dish — recipes crafted to showcase our premium seasonings</p>
        </div>
      </div>

      <div className="container recipes-container">
        {recipesData.map((section, sectionIdx) => (
          <section key={sectionIdx} className="seasoning-section">
            <div className="seasoning-hero-card" style={{ borderColor: section.color }}>
              <div className="seasoning-badge" style={{ backgroundColor: section.color }}>
                <i className="fas fa-pepper-hot"></i>
              </div>
              <h2 className="seasoning-name" style={{ color: section.color }}>{section.seasoning}</h2>
              <p className="seasoning-profile">{section.profile}</p>
            </div>

            <div className="recipe-cards-grid">
              {section.recipes.map((recipe) => (
                <div key={recipe.id} className="recipe-card">
                  {recipe.image && (
                    <div className="recipe-image-wrapper">
                      <img 
                        src={recipe.image} 
                        alt={recipe.title} 
                        className="recipe-image"
                        onClick={() => toggleRecipe(recipe.id)}
                        style={{ cursor: 'pointer' }}
                      />
                      <div className="recipe-image-overlay" onClick={() => toggleRecipe(recipe.id)}>
                        <i className="fas fa-utensils"></i>
                        <span>Click to {expandedRecipe === recipe.id ? 'hide' : 'view'} recipe</span>
                      </div>
                    </div>
                  )}
                  
                  <div className="recipe-card-header">
                    <h3 className="recipe-title">{recipe.title}</h3>
                    <p className="recipe-description">{recipe.description}</p>
                  </div>

                  <div className="recipe-card-body">
                    <button 
                      className="recipe-toggle-btn"
                      onClick={() => toggleRecipe(recipe.id)}
                      style={{ borderColor: section.color }}
                    >
                      <i className={`fas fa-chevron-${expandedRecipe === recipe.id ? 'up' : 'down'}`}></i>
                      {expandedRecipe === recipe.id ? 'Hide' : 'View'} Recipe Details
                    </button>

                    {expandedRecipe === recipe.id && (
                      <div className="recipe-details">
                        <div className="recipe-section">
                          <h4><i className="fas fa-shopping-basket"></i> Ingredients</h4>
                          <ul className="ingredients-list">
                            {recipe.ingredients.map((ingredient, idx) => (
                              <li key={idx}>{ingredient}</li>
                            ))}
                          </ul>
                        </div>

                        <div className="recipe-section">
                          <h4><i className="fas fa-list-ol"></i> Instructions</h4>
                          <ol className="instructions-list">
                            {recipe.instructions.map((step, idx) => (
                              <li key={idx}>{step}</li>
                            ))}
                          </ol>
                        </div>

                        {recipe.serving && (
                          <div className="recipe-section serving-suggestion">
                            <h4><i className="fas fa-utensils"></i> Serving Suggestion</h4>
                            <p>{recipe.serving}</p>
                          </div>
                        )}

                        <div className="recipe-actions">
                          <button 
                            className="recipe-action-btn copy-btn"
                            onClick={() => copyRecipe(recipe)}
                            style={{ backgroundColor: section.color }}
                          >
                            <i className="fas fa-copy"></i> Copy Recipe
                          </button>
                          <button 
                            className="recipe-action-btn print-btn"
                            onClick={() => printRecipe(recipe)}
                            style={{ borderColor: section.color, color: section.color }}
                          >
                            <i className="fas fa-print"></i> Print Recipe
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default Recipes;
